import React from 'react'
import FacebookButton from '@jarvis.oddle/core/components/ExternalButtons/FacebookButton'
import pickUpDeliveryFlow from 'src/flows/pickUpDeliveryFlow'

const FacebookLogin = React.memo(
  ({
    facebookAppId,
    facebookRedirectUrl,
    storeOrderId,
    menuId
  }: {
    facebookAppId: string
    facebookRedirectUrl: string
    storeOrderId: string
    menuId: string
  }) => {
    const [fetching, setFetching] = React.useState(false)

    const onClick = React.useCallback(() => {
      setFetching(true)
      // prevent 500 - internal server error
      const currentUrl = window.location.href.split('#')[0]
      // NOTE: `version=v4` is required by backend to identify Oddle Shop or OMS shopping cart
      const stateParam = `url=${currentUrl},store_order_id=${storeOrderId},menu_id=${menuId},version=V4`
      const facebookUrl = `https://www.facebook.com/v3.0/dialog/oauth?client_id=${facebookAppId}&redirect_uri=${facebookRedirectUrl}&fields=id,name,email&scope=public_profile,email&state={${stateParam}}`

      window.localStorage.setItem(
        'pickupDeliveryFlow.isVisited',
        pickUpDeliveryFlow.getMeta().isVisited
      )
      window.location.href = facebookUrl
    }, [facebookAppId, facebookRedirectUrl, menuId, storeOrderId])

    return <FacebookButton onClick={onClick} fetching={fetching} />
  }
)

export default FacebookLogin
